// extracted by mini-css-extract-plugin
export default {"filtersWrapper":"M6PElR","mobile":"V_lgmT","overflowWrapper":"ignAGj"};